export const reservationInvoicePanel = {
  loadingVerifying: "جارٍ التحقق…",

  status: {
    draft: "مسودة",
    sent: "صادرة",
    processing: "قيد المعالجة",
    pending: "قيد الانتظار",
    error: "خطأ",
    corrected: "مُصحَّحة",
    voided: "مُلغاة",
  },

  common: {
    cancel: "إلغاء",
    understood: "حسناً",
    optional: "اختياري",
    optionalParen: "(اختياري)",
    sending: "جارٍ الإرسال…",
    saving: "جارٍ الحفظ…",
    deleting: "جارٍ الحذف…",
    emitting: "جارٍ الإصدار…",
    creating: "جارٍ الإنشاء…",
    retrying: "جارٍ إعادة المحاولة…",
  },

  issued: {
    title: "الفواتير الصادرة",
    rectifOf: "تصحيح لـ {code}",
    viewPdf: "عرض PDF",
    sendByWhatsapp: "الإرسال عبر واتساب",
    correctTitle: "تصحيح (فاتورة تصحيحية)",
    voidTitle: "إلغاء (فاتورة تصحيحية)",
  },

  empty: {
    guestRequested: "طلب الضيف فاتورته",
    noInvoice: "لم تُصدَر فاتورة",
    linkSent: "تم إرسال الرابط",
    requested: "مطلوبة",
    requestedSub: "راجع بياناته وأصدر الفاتورة، أو أرسل له الرابط ليؤكدها.",
    sub: "أرسل الرابط إلى الضيف أو أنشئ الفاتورة مباشرة.",
    copyLinkTitle: "نسخ الرابط إلى الحافظة",
    sendLink: "إرسال الرابط",
    createInvoice: "إنشاء فاتورة",
    configureHint: "اضبط بيانات الفوترة لتفعيل هذه الميزة.",
  },

  next: {
    title: "هذا الحجز لديه فاتورته بالفعل",
    sub: "هل طرأ رسم لاحق؟ أنشئ فاتورة أخرى لهذا الحجز: ستتضمن الرسوم الجديدة فقط (لا يُكرَّر الإيواء الذي سبقت فوترته).",
    button: "إنشاء فاتورة أخرى لهذا الحجز",
  },

  card: {
    draftRefTitle: "مرجع داخلي للمسودة. يُخصَّص الرقم الضريبي عند الإصدار.",
  },

  draft: {
    emptyHint: 'أضف رسماً واحداً على الأقل في <b>“الرسوم الجديدة”</b> لتتمكن من إصدار هذه الفاتورة.',
    noteLead: "مسودة — عدّل البيانات أو أضف الرسوم أعلاه؛ يُخصَّص الرقم والتاريخ عند <b>الإصدار</b>.",
    nextSequential: "الرقم التسلسلي التالي",
    estimated: "تقديري",
    noteFoot: "الرقم غير نهائي: أول من يُصدر يحصل عليه.",
    confirmEmit: "تأكيد وإصدار الفاتورة",
    previewPdf: "معاينة PDF",
    sendQuote: "إرسال عرض السعر",
    edit: "تعديل الفاتورة",
    discard: "تجاهل",
  },

  // بنود المستند الجاري: ما يُراجَع قبل الإصدار.
  concepts: {
    title: "بنود المستند",
    item: "البند",
    qty: "الكمية",
    unitPrice: "سعر الوحدة",
    vat: "ضريبة",
    amount: "المبلغ",
    linesTotal: "مجموع البنود",
    foot: "هكذا سيظهر التفصيل في الفاتورة. وملف PDF يحتوي على التفصيل الكامل.",
    mismatch: "مجموع البنود ({lines}) لا يطابق إجمالي المستند ({total}). راجعه قبل الإصدار.",
  },

  // Lo cobrado y lo que queda a deber. Mismas palabras y mismo orden que el
  // pie del PDF, para que leer la pantalla y leer la factura sea lo mismo.
  cobro: {
    total: "إجمالي المستند",
    nothing: "لا توجد مدفوعات مسجلة",
    due: "المبلغ المستحق",
    assumed: "لا توجد مدفوعات مسجلة على هذا الحجز. يُعتبر المبلغ محصّلاً بناءً على طريقة الدفع المحددة، وسيظهر كذلك في ملف PDF. إذا لم تستلم المبلغ بعد، فسجّل الدفعة أو غيّر طريقة الدفع.",
  },

  actions: {
    sendWhatsapp: "إرسال عبر واتساب",
    correct: "تصحيح",
    void: "إلغاء",
    refresh: "تحديث",
    retry: "إعادة المحاولة",
    editData: "تعديل البيانات",
    delete: "حذف",
  },

  wa: {
    title: "إرسال الفاتورة عبر واتساب",
    desc: "سيتم إرسال الفاتورة <strong>{code}</strong> بصيغة PDF إلى الضيف عبر واتساب.",
    issuedFallback: "الصادرة",
    checkPhone: "سيُستخدم هاتف الضيف المرتبط بالحجز",
    checkPdf: "سيُرسَل المستند بصيغة PDF",
    send: "إرسال الفاتورة",
  },

  sendLink: {
    title: "إرسال رابط الفوترة",
    desc: "سيُرسَل إلى الضيف <strong>رابط عبر واتساب</strong> ليؤكد بياناته الضريبية ويُنزّل فاتورته.",
    checkNoInvoice: "لا تُصدَر أي فاتورة بعد: يتلقى الضيف الرابط فقط",
    button: "إرسال الرابط",
  },

  retryModal: {
    title: "إعادة محاولة الإصدار",
    desc: "ستتم إعادة محاولة <strong>إصدار هذه الفاتورة</strong> بالبيانات الحالية.",
    check1: "يُعاد الإرسال إلى هيئة الفوترة الإلكترونية",
    check2: "في حال النجاح يُخصَّص الرقم الضريبي النهائي",
  },

  voidModal: {
    doneTitle: "أُلغيت الفاتورة — صدر فاتورة تصحيحية",
    creditNoteIssued: "صدر فاتورة تصحيحية <strong>{code}</strong>",
    chargesReleased: "تم تحرير الرسوم الإضافية",
    clientCanRequest: "يمكن للعميل طلب الفاتورة مجدداً",
    doneHint: "أضف أو صحّح الرسوم المعلّقة وأنشئ فاتورة جديدة.",
    formTitle: "إلغاء الفاتورة / إصدار فاتورة تصحيحية",
    formDesc: "استخدم هذا الخيار عندما تحتاج إلى <strong>إضافة أو تغيير الخدمات/المبالغ</strong>. سيصدر <strong>فاتورة تصحيحية</strong> يُلغي الفاتورة الأصلية، وستتمكن من إنشاء فاتورة جديدة بالرسوم الصحيحة.",
    stepAnnul: "يصدر فاتورة تصحيحية ضريبي يُلغي {code}",
    stepFree: "تصبح الرسوم متاحة للإضافة أو التصحيح",
    stepNewNumber: "تُنشأ فاتورة جديدة بالرقم التالي",
    notice: "لتصحيح NIF أو الاسم أو العنوان فقط دون تغيير المبالغ، استخدم <strong>تصحيح البيانات</strong> بدلاً من ذلك.",
    voiding: "جارٍ إصدار فاتورة تصحيحية…",
    confirm: "إلغاء وإصدار فاتورة تصحيحية",
  },

  edit: {
    titleDraft: "تعديل الفاتورة",
    titleClient: "تعديل بيانات العميل",
    descDraft: "تُحفظ التغييرات فوراً. تُتحقَّق البيانات الضريبية دون إصدار.",
    descSent: "عند الحفظ ستتم إعادة محاولة الإرسال تلقائياً.",
    type: "النوع",
    individual: "فرد",
    individualSub: "شخص طبيعي",
    company: "شركة",
    companySub: "شخص اعتباري",
    legalName: "الاسم القانوني",
    fullName: "الاسم الكامل",
    legalNamePlaceholder: "الاسم القانوني للشركة",
    fullNamePlaceholder: "الاسم واللقب",
    country: "الدولة",
    countryPlaceholder: "اختر دولة الضيف",
    taxRequiredOnEmit: "إلزامي عند الإصدار",
    taxIdPlaceholderCompany: "NIF / CIF الخاص بالشركة",
    taxIdPlaceholderIndividual: "DNI / NIE · فارغ = مستهلك نهائي",
    email: "البريد الإلكتروني",
    emailPlaceholder: "email@example.com",
    phone: "الهاتف",
    phonePlaceholder: "+34 600 000 000",
    fiscalAddress: "العنوان الضريبي",
    addressPlaceholder: "الشارع والرقم",
    city: "المدينة",
    region: "المنطقة / المحافظة",
    zip: "الرمز البريدي",
    saveChanges: "حفظ التغييرات",
    saveAndRetry: "حفظ وإعادة المحاولة",
  },

  deleteModal: {
    title: "حذف الفاتورة",
    desc: "ستُحذف محاولة الفاتورة هذه. سيتمكن العميل من طلب الفاتورة من جديد من البداية.",
    noticeIrreversible: "لا يمكن التراجع عن هذا الإجراء.",
  },

  emit: {
    title: "تأكيد وإصدار الفاتورة",
    subtitle: "تُسجَّل رسمياً",
    desc: "أنت على وشك إصدار فاتورة {name}.",
    stepNumberEstimate: "يُخصَّص لها الرقم التسلسلي <b>{code}</b> — أول من يُصدر يحصل عليه.",
    stepNumberFinal: "يُخصَّص لها الرقم التسلسلي <b>النهائي</b> — أول من يُصدر يحصل عليه.",
    stepPdf: "يُنشأ ملف PDF الضريبي ويُسجَّل لدى مصلحة الضرائب.",
    warn: "بمجرد الإصدار <b>لا يمكن تعديلها</b>. في حال وجود خطأ، يجب <b>إلغاؤها وإنشاء فاتورة جديدة</b> (فاتورة تصحيحية أو فاتورة تصحيحية).",
    confirm: "تأكيد وإصدار",
  },

  newInvoice: {
    title: "إنشاء فاتورة أخرى",
    subtitle: "لنفس هذا الحجز",
    desc: "ستُفتح <strong>مسودة جديدة</strong> لهذا الحجز.",
    step1: "ستتضمن <b>الرسوم الجديدة فقط</b> التي تضيفها — لا يُكرَّر الإيواء الذي سبقت فوترته.",
    step2: "تأخذ بيانات العميل نفسه. يُخصَّص الرقم عند الإصدار.",
    createDraft: "إنشاء مسودة",

    // Facturar toda la reserva o una sola habitación (reservas de varias).
    scopeTitle: "كيف تريد إصدار الفاتورة؟",
    whole: "الحجز بالكامل",
    wholeHint: "فاتورة واحدة تشمل {n} غرف.",
    perRoom: "غرفة واحدة",
    perRoomHint: "لكل غرفة فاتورتها. عندما يدفع كل نزيل حصته.",
    pickRoom: "اختر الغرفة",
    roomLodging: "الإقامة",
    alreadyInvoiced: "تمت فوترتها",
  },

  correction: {
    doneTitle: "صدرت الفاتورة التصحيحية",
    createdOk: "أُنشئت الفاتورة التصحيحية <strong>{code}</strong> بنجاح",
    originalKept: "تبقى الفاتورة الأصلية كمرجع ضريبي (لا تُحذف)",
    pdfSoon: "سيُنشأ ملف PDF خلال لحظات",
    title: "تصحيح الفاتورة",
    infobox: "سيصدر <strong>فاتورة تصحيحية تصحيحي</strong> يحل ضريبياً محل <strong>{code}</strong> ويتضمن الرسوم الحالية للحجز. لا يمكن تعديل الرقم الأصلي (بحكم القانون).",
    reasonLabel: "سبب التصحيح",
    selectReason: "— اختر السبب —",
    reasonTaxId: "NIF / CIF أو Tax ID غير صحيح",
    reasonName: "الاسم أو الاسم القانوني غير صحيح",
    reasonAddress: "العنوان الضريبي غير صحيح",
    reasonEmail: "البريد الإلكتروني غير صحيح",
    reasonGeneral: "تصحيح عام للبيانات الضريبية",
    reasonOther: "أخرى (اكتب السبب)",
    customReasonPlaceholder: "صف سبب التصحيح…",
    recipientDivider: "بيانات المستلم — عدّل فقط ما تحتاج إلى تصحيحه",
    nameOrLegalName: "الاسم / الاسم القانوني",
    taxIdFull: "NIF / CIF / Tax ID / جواز السفر",
    countryTwoLetters: "(حرفان)",
    paymentDivider: "طريقة الدفع",
    paymentLabel: "وسيلة الدفع",
    paymentUnspecified: "— غير محدَّد —",
    paymentCash: "نقداً",
    paymentCard: "بطاقة ائتمان / خصم",
    paymentTransfer: "تحويل بنكي",
    paymentStripe: "Stripe (عبر الإنترنت)",
    emitRectif: "إصدار فاتورة تصحيحية",
  },

  request: {
    typeCompany: "شركة",
    typeIndividual: "فرد",
    type: "النوع",
    legalName: "الاسم القانوني / الاسم",
    taxId: "NIF / CIF",
    address: "العنوان",
    postalCode: "الرمز البريدي",
    city: "المدينة",
    state: "المحافظة",
    country: "الدولة",
    email: "البريد الإلكتروني",
  },

  toast: {
    linkSent: "تم إرسال رابط الفوترة إلى الضيف عبر واتساب.",
    alreadyIssued: "هذا الحجز لديه فاتورة صادرة بالفعل.",
    cantSendLink: "تعذّر إرسال الرابط.",
    linkCopied: "تم نسخ الرابط إلى الحافظة.",
    alreadyHasInvoice: "هذا الحجز لديه فاتورة بالفعل.",
    cantGenerateLink: "تعذّر إنشاء الرابط.",
    cantSendWhatsapp: "تعذّر الإرسال عبر واتساب.",
    invoiceSentWhatsapp: "تم إرسال الفاتورة عبر واتساب.",
    draftCreatedNewCharges: "أُنشئت المسودة بالرسوم الجديدة (دون تكرار الإيواء). راجعها وأصدرها.",
    draftCreated: "أُنشئت المسودة. أضف الرسوم وأصدرها عندما تكون جاهزة.",
    alreadyInProgress: "هذا الحجز لديه فاتورة قيد الإنجاز بالفعل.",
    cantCreateDraft: "تعذّر إنشاء المسودة.",
    invoiceEmitted: "صدرت الفاتورة. جارٍ إنشاء الرقم وملف PDF…",
    cantEmit: "تعذّر إصدار الفاتورة.",
    cantPreview: "تعذّر إنشاء المعاينة.",
    quoteSent: "أُرسل عرض السعر إلى {email}",
    cantSendQuote: "تعذّر إرسال عرض السعر",
    cantSync: "تعذّرت مزامنة الحالة.",
    retrying: "جارٍ إعادة محاولة الإصدار…",
    cantRetry: "تعذّرت إعادة المحاولة.",
    cantVoid: "خطأ في إلغاء الفاتورة.",
    savedCheckFiscal: "تم الحفظ. راجع المستند الضريبي.",
    dataUpdated: "تم تحديث البيانات.",
    cantSaveData: "تعذّر حفظ البيانات.",
    invoiceDeleted: "تم حذف الفاتورة.",
    cantDelete: "تعذّر الحذف.",
    cantEmitRectif: "خطأ في إصدار الفاتورة التصحيحية.",
  },
};
